import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "./StructureChanges.scss";
import {
  ViedocButtonElement,
  ViedocDialogElement,
} from "../../../../../secure/elements/ViedocReactElements";
import _ from "underscore";
import APP_CONST from "../../../../shared/constants";
import Loader from "../../../shared/Loader/Loader";
import * as templateActions from "../../../../../store/actions/templateActions";

const StructureChanges = ({ setApplyRevertVisible, isApply, setIsChecked }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { isChangeLoading, changeditems, tmfStructureData } = useSelector(
    (store) => store.template
  );
  const [listOfChanges, setListOfChanges] = useState(changeditems);

  useEffect(() => {
    setListOfChanges(changeditems);
  }, [changeditems]);

  const onHide = () => {
    setApplyRevertVisible(false);
  };

  //Page render component
  const renderStructureHeader = () => {
    return (
      <header className="pl-10" slot="header">
        <p className="f21 mt-5">{t("ADMIN.TEXT_STRUCTURECHANGES")}</p>
      </header>
    );
  };

  const returnList = (list) => {
    const listCategory = list.category.toLowerCase();
    const returnElement = () => {
      switch (listCategory) {
        case "zone":
          return (
            <ul>
              <li>{list.zonename}</li>
            </ul>
          );
        case "section":
          return (
            <ul>
              <li>{list.zonename}</li>
              <li>{list.sectionname}</li>
            </ul>
          );
        case "artifact":
          return (
            <ul>
              <li>{list.zonename}</li>
              <li>{list.sectionname}</li>
              <li>{list.artifactname}</li>
            </ul>
          );

        case "milestone":
          return (
            <ul>
              <li>{list.milestonename}</li>
            </ul>
          );
        default:
          break;
      }
    };
    let actionType = APP_CONST.FORM_CURRENT_ACTION_OBJECT[list.action];
    let actType = "";
    let type = "";
    if (actionType === "Added new") {
      actType = t("ADMIN.TEXT_ADDEDNEW");
    } else if (actionType === "Edited") {
      actType = t("ADMIN.TEXT_EDITED");
    } else if (actionType === "Deleted") {
      actType = t("ADMIN.TEXT_DELETED");
    }
    if (listCategory === "zone") {
      type = t("ADMIN.TEXT_ZONE");
    } else if (listCategory === "section") {
      type = t("ADMIN.TEXT_SECTION");
    } else if (listCategory === "artifact") {
      type = t("ADMIN.TEXT_ARTIFACT");
    } else if (listCategory === "milestone") {
      type = t("ADMIN.TEXT_MILESTONE");
    } else if (listCategory === "structure_name") {
      type = t("ADMIN.TEXT_STRUCTURENAME");
    } else if (listCategory === "tmf_reference_model_version") {
      type = t("ADMIN.TEXT_TMFMODELVERSION");
    }

    return (
      <>
        <span>{`${actType} ${type} `}</span>
        {returnElement()}
      </>
    );
  };

  const rendersStructureBody = () => {
    return (
      <div className="structure-popup-body">
        <p className="structure-popup-title">
          {t("ADMIN.TEXT_FOLLOWINGCHANGESMADE")}
        </p>
        <div className="structure-content">
          {!_.isEmpty(listOfChanges) &&
            listOfChanges.map((changes, index) => (
              <div className="structure-artifacts d-flex" key={index}>
                <div className="structure-number">{index + 1}</div>
                <div className="structure-artifact-content d-flex">
                  {returnList(changes)}
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  };

  const structureChangesHandler = () => {
    let structurePayload = {};
    if (isApply) {
      dispatch(templateActions.applyStructureChange(structurePayload));
    } else {
      structurePayload = {
        lastModifiedOn: tmfStructureData.lastmodifiedon || "",
      };
      dispatch(templateActions.revertStructureChange(structurePayload));
    }
    dispatch(templateActions.clearChangesFound());
    setIsChecked(false);
    onHide();
  };

  const renderStructureFooter = () => {
    return (
      <div className="structure-footer bt-2">
        <p className="f14 text-center">
          {t("ADMIN.TEXT_CLICK")}
          <span>
            {isApply
              ? t("ADMIN.BUTTON_APPLYCHANGES")
              : t("ADMIN.BUTTON_REVERTCHANGES")}
          </span>
          {`${t("ADMIN.TEXT_TO")} ${
            isApply ? t("ADMIN.TEXT_PUBLISH") : t("ADMIN.TEXT_REVERT")
          } ${t("ADMIN.TEXT_CHANGESPOPUPINFO")}`}
        </p>

        <div className="structure-btn d-flex">
          <ViedocButtonElement
            variant={isApply ? "success" : "secondary"}
            title={
              isApply
                ? t("ADMIN.BUTTON_APPLYCHANGES")
                : t("ADMIN.BUTTON_REVERTCHANGES")
            }
            onClick={() => structureChangesHandler()}
          >
            <div className="d-flex structure-footer-color">
              <viedoc-icon name={isApply ? "check" : "delete"} />{" "}
              <span>
                {isApply
                  ? t("ADMIN.BUTTON_APPLYCHANGES")
                  : t("ADMIN.BUTTON_REVERTCHANGES")}
              </span>
            </div>
          </ViedocButtonElement>
        </div>
      </div>
    );
  };

  return (
    <ViedocDialogElement
      size="medium"
      open
      preventCloseByClick
      class="edit-artifact-popup"
      onHide={() => onHide()}
    >
      {renderStructureHeader()}
      {isChangeLoading ? (
        <Loader width={"100%"} height={"100%"} borderRadius />
      ) : (
        <>
          {rendersStructureBody()}

          {renderStructureFooter()}
        </>
      )}
    </ViedocDialogElement>
  );
};

export default StructureChanges;
